import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { CreateChargePaymentError } from '#src/app/shared/utils/payments';

import type {
	CreatePromotionChargeForComboMutation,
	CreatePromotionChargeForComboMutationVariables,
	CreatePromotionForComboStripeGatewayDataFragment,
} from './api.graphql';
import { CreatePromotionChargeForCombo } from './api.graphql';

export type StripeGatewayData = CreatePromotionForComboStripeGatewayDataFragment;
export type CreateChargeInput = CreatePromotionChargeForComboMutationVariables['chargeInput'];
export type CreatePromotionChargeInput = CreatePromotionChargeForComboMutationVariables['promotionChargeInput'];

export async function createPromotionCharge(
	chargeInput: CreateChargeInput,
	promotionChargeInput: CreatePromotionChargeInput,
	{ gql: { fetch } }: UtilityContext,
): Promise<StripeGatewayData | undefined> {
	const { data, errors } = await fetch<
		CreatePromotionChargeForComboMutation,
		CreatePromotionChargeForComboMutationVariables
	>({
		query: CreatePromotionChargeForCombo,
		variables: {
			chargeInput,
			promotionChargeInput,
		},
		path: '/payments/createPromotionCharge',
		rejectOnError: false,
		batched: false, // to ensure this rate limited mutation is not batched
	});

	if (errors) throw new Error(JSON.stringify(errors));
	if (!data) throw new Error('Empty data in createPromotionCharge graphQL response');
	const result = data.createPromotionCharge;

	if (result.__typename === 'CreateChargePaymentError' || result.__typename === 'CreateChargeValidationError')
		throw new CreateChargePaymentError(result);

	if (result.gatewayData?.__typename === 'StripeGatewayData') {
		return result.gatewayData;
	}
	return undefined;
}
